import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const getBaseQuery = (url) =>
    fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BASE_URL}${url}`,
        prepareHeaders: (headers, { getState }) => {
            headers.set('authorization', `Bearer ${getState().auth.accessToken}`);
            return headers;
        },
    });
